import React, { useState } from 'react';


const StarRating = ({ totalStars = 5, onRate, icon }) => {
    const [hover, setHover] = useState(0);
    const [rating, setRating] = useState(0);

    const handleRating = (val) => {
        setRating(val);
        if (onRate) onRate(val);
    };

    return (
        <div style={{ display: 'flex', gap: '8px', justifyContent: 'space-between', width: '100%' }}>
            {[...Array(totalStars)].map((_, index) => {
                const starValue = index + 1;
                const isActive = starValue <= (hover || rating);

                return (
                    <div
                        key={index}
                        onClick={() => handleRating(starValue)}
                        onMouseEnter={() => setHover(starValue)}
                        onMouseLeave={() => setHover(0)}
                        style={{
                            cursor: 'pointer',
                            transition: 'all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                            transform: isActive ? 'scale(1.15)' : 'scale(1)',
                            
                            filter: isActive 
                                ? 'drop-shadow(0 0 8px rgba(33, 255, 85, 0.8))' 
                                : 'grayscale(100%) opacity(0.3)',
                        }}
                    >
                        {icon ? (
                            <img 
                                src={icon} 
                                alt="star" 
                                style={{ 
                                    width: '100%', 
                                    height: '100%',
                    
                                    filter: isActive ? 'none' : 'brightness(0.5) invert(1)' 
                                }} 
                            />
                        ) : (
                            <svg width="35" height="35" viewBox="0 0 24 24" fill={isActive ? "#21FF55" : "none"} stroke={isActive ? "#21FF55" : "white"} strokeWidth="2">
                                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                            </svg>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default StarRating;